'use strict';

const initialStyles = {
    overflow: '',
    position: '',
    width: '',
    top: '',
    pageYOffset: 0,
    pageXOffset: 0,
};
let previousStyles = { ...initialStyles };
let dialogsCount = 0;
function preventBodyScroll(preventScroll) {
    /** Apply or remove styles to prevent body scroll.
     *
     * Note, simple using the style 'overflow: hidden' on the body does't have the expected effect on
     * the IOS (Safari), described in detail here https://bugs.webkit.org/show_bug.cgi?id=153852
     */
    const body = document.body.style;
    // Helper function
    const saveExistingStyles = () => {
        previousStyles = {
            overflow: body.overflow,
            position: body.position,
            width: body.width,
            top: body.top,
            pageYOffset: window.pageYOffset,
            pageXOffset: window.pageXOffset,
        };
    };
    // Helper function
    const setPreventScrollStyles = () => {
        body.overflow = 'hidden';
        body.position = 'fixed';
        body.width = '100vw';
        body.top = `${(-previousStyles.pageYOffset).toString()}px`;
    };
    // Helper function
    const restoreStyles = () => {
        body.overflow = previousStyles.overflow;
        body.position = previousStyles.position;
        body.width = previousStyles.width;
        body.top = previousStyles.top;
        if (previousStyles.pageYOffset || previousStyles.pageXOffset) {
            window.scrollTo(previousStyles.pageXOffset, previousStyles.pageYOffset);
        }
        previousStyles = { ...initialStyles };
        dialogsCount = 0;
    };
    // Main prevent body scroll logic
    if (preventScroll) {
        dialogsCount = (dialogsCount || 0) + 1;
        if (dialogsCount > 1)
            return;
        saveExistingStyles();
        setPreventScrollStyles();
    }
    else {
        dialogsCount = dialogsCount - 1 > 0 ? dialogsCount - 1 : 0;
        if (dialogsCount > 0)
            return;
        restoreStyles();
    }
}

exports.preventBodyScroll = preventBodyScroll;
//# sourceMappingURL=preventBodyScroll.js.map
